import { Col, Form, Row } from "antd";
import { LocalSelect } from "../../generales/locales/LocalSelect";

export const EmpleadoLocales = () => {
  return (
    <Row gutter={[8, 8]}>
      <Col span={24}>
        <Form.Item
          label="Locales"
          name="LocalesEmpleado"
          rules={[
            {
              type: "array",
              min: 1,
              message: "Seleccione al menos 1 Local",
            },
          ]}
        >
          <LocalSelect
            allowClear
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="[-Selecione Locales-]"
          />
        </Form.Item>
      </Col>
    </Row>
  );
};
